import { type Dispatch, type SetStateAction, createContext, useContext } from 'react'

type MediaContextType = {
  isMobile: boolean
  setMediaState?: Dispatch<SetStateAction<boolean>>
}

const initialMediaContext: MediaContextType = {
  isMobile: true,
  setMediaState: () => {},
}

export const MediaContext = createContext<MediaContextType>(initialMediaContext)

export const useMediaContext = () => {
  return useContext(MediaContext)
}
